import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
    { label: "Services", href: "#services", testid: "nav-link-services" },
    { label: "Approach", href: "#approach", testid: "nav-link-manifesto" },
    { label: "Why Us", href: "#why-us", testid: "nav-link-why-us" },
    { label: "Contact", href: "#contact", testid: "nav-link-contact" },
];

const Nav = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (e, href) => {
        e.preventDefault();
        scrollToId(href);
    };

    return (
        <header
            data-testid="nav-header"
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "border-b border-white/5 bg-navy/80 backdrop-blur-xl"
                    : "bg-transparent"
            }`}
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    onClick={(e) => go(e, "#hero")}
                    className="flex items-center gap-3"
                >
                    <img
                        src="/adminlogic-logo-dark.png"
                        alt="Admin Logic Services Ltd"
                        className="h-12 w-auto transition-all duration-500 sm:h-14"
                    />
                </a>

                <nav className="hidden items-center gap-9 md:flex">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.testid}
                            onClick={(e) => go(e, l.href)}
                            className="group relative font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400 transition-colors duration-300 hover:text-white"
                        >
                            {l.label}
                            <span className="absolute -bottom-1 left-0 h-px w-0 bg-amber-400 transition-all duration-300 group-hover:w-full" />
                        </a>
                    ))}
                </nav>

                <button
                    data-testid="nav-cta-btn"
                    onClick={(e) => go(e, "#contact")}
                    className="group flex items-center gap-2 rounded-full border border-electric/40 bg-electric/10 px-5 py-2.5 text-sm font-semibold text-blue-200 transition-all duration-300 hover:border-amber-400/60 hover:bg-amber-400 hover:text-navy"
                >
                    Get in touch
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
            </div>
        </header>
    );
};

export default Nav;
